module.exports = __webpack_public_path__ + "img/3.95fb3e63.png";